import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { getToken } from "./api";
import { SideNav } from "./components/SideNav";
import { SiteSwitcher } from "./components/SiteSwitcher";
import { TabBar } from "./components/TabBar";
import { Account } from "./routes/Account";
import { History } from "./routes/History";
import { Home } from "./routes/Home";
import { Live } from "./routes/Live";
import { Login } from "./routes/Login";
import { Prijzen } from "./routes/Prijzen";
import { Prognose } from "./routes/Prognose";
import { SmartDevices } from "./routes/SmartDevices";
import { useSwipeNav } from "./useSwipeNav";

function Protected({ children }: { children: React.ReactNode }) {
  return getToken() ? <>{children}</> : <Navigate to="/login" replace />;
}

export default function App() {
  const loc = useLocation();
  // Hide the tab bar on the login screen - it is not a
  // logged-in tab context, and the bar just steals safe-area padding.
  const showTabs = loc.pathname !== "/login";
  // Document-level horizontal-swipe → previous/next tab. Internally
  // ignores touches that start inside `[data-swipe-consume="true"]`
  // (the chart) so its scrub gesture isn't hijacked.
  useSwipeNav();

  return (
    <>
      {/* Desktop-rail; onder lg onzichtbaar (mobiel = TabBar-pill). */}
      {showTabs && <SideNav />}
      {/* pt-safe = env(safe-area-inset-top): 0 op het web, de
          statusbalkhoogte in een edge-to-edge native venster.
          lg:pl-60 schuift de content naast de vaste rail. */}
      <div className={showTabs ? "pt-safe lg:pl-60" : "pt-safe"}>
      {/* Rendert null bij één installatie - gewone klanten zien niets. */}
      {showTabs && <SiteSwitcher />}
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* Public: QR deep-link target from the claim sticker. Reachable
            without a session - a brand-new customer scanning the box. */}
        <Route
          path="/"
          element={
            <Protected>
              <Home />
            </Protected>
          }
        />
        <Route
          path="/history"
          element={
            <Protected>
              <History />
            </Protected>
          }
        />
        <Route
          path="/live"
          element={
            <Protected>
              <Live />
            </Protected>
          }
        />
        <Route
          path="/prijzen"
          element={
            <Protected>
              <Prijzen />
            </Protected>
          }
        />
        <Route
          path="/prognose"
          element={
            <Protected>
              <Prognose />
            </Protected>
          }
        />
        <Route
          path="/account"
          element={
            <Protected>
              <Account />
            </Protected>
          }
        />
        <Route
          path="/account/slim"
          element={
            <Protected>
              <SmartDevices />
            </Protected>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </div>
      {showTabs && <TabBar />}
    </>
  );
}
